export default __webpack_public_path__ + "static/media/mario_bike.304fa388.jpg";